import { Puzzle } from './Puzzle';
import Image from './Image';
import Button from './Button';

export class RoomContent {
    type: string;
    constructor(type = 'none'){
        this.type = type;
    }
}

export class RoomContentText extends RoomContent {

    text: string;

    constructor(text: string){
        super('text');
        this.text = text;
    }

}

export class RoomContentPuzzle extends RoomContent {

    puzzle: Puzzle;

    constructor(puzzle: Puzzle){
        super('puzzle');
        this.puzzle = puzzle;
    }
}

export class RoomContentImage extends RoomContent {

    image: Image;

    constructor(image: Image){
        super('image');
        this.image = image;
    }
}

export class RoomContentButton extends RoomContent {

    button: Button;

    constructor(button: Button){
        super('button');
        this.button = button;
    }
}



export default class Room {

    static current_id = 0;

    id:string
    name: string;
    status: string;
    content: RoomContent[] = [];

    constructor(name: string, status='closed'){

        this.id = `rom-${++Room.current_id}`;

        this.name = name;
        this.status = status;
    }

    add(content: string|Puzzle|Image|Button){

        if(typeof content === 'string'){
            this.content.push(new RoomContentText(content));
            return;
        }

        if(content instanceof Puzzle){
            this.content.push(new RoomContentPuzzle(content));
            return;
        }

        if(content instanceof Image){
            this.content.push(new RoomContentImage(content));
            return;
        }

        if(content instanceof Button){
            this.content.push(new RoomContentButton(content));
            return;
        }

    }


    getElement(id:string){

        for(let cont of this.content){

            if(cont instanceof RoomContentImage){
                if(id === cont.image.id){
                    return cont.image;
                }
            }
            if(cont instanceof RoomContentPuzzle){
                if(id === cont.puzzle.id){
                    return cont.puzzle;
                }

                for(let hint of cont.puzzle.hints){
                    if(id === hint.id) return hint;
                }

            }
            if(cont instanceof RoomContentButton){
                if(id === cont.button.id){
                    return cont.button;
                }
            }

        }

        return null;

    }



    async preload(){

        console.log("Preload room");

        const waits:Promise<void>[] = [];

        this.content.forEach(content => {

            if(content instanceof RoomContentImage){
                console.log("Wait for image", content);
                waits.push(content.image.preload());
            }

        });

        console.log("Preload room", waits.length);


        await Promise.all(waits);

    }


}